import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/${dossierId}/DeliveryComponentHistorical`, method: 'GET', token: token })
}
